import { render, staticRenderFns } from "./payment-result-list.vue?vue&type=template&id=9db23b22&"
import script from "./payment-result-list.vue?vue&type=script&lang=js&"
export * from "./payment-result-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports